package com.yogaaicoach.pages.payment.data

import com.yogaaicoach.common.network.ApiClient
import io.ktor.http.HttpMethod
import kotlinx.serialization.Serializable

@Serializable
data class CreateSessionRequest(
    val successUrl: String,
    val cancelUrl: String,
    val subscriptionType: String // Todo I think this should be enum
)

@Serializable
data class CreateSessionResponse(
    val url: String
)

@Serializable
data class VerifyGooglePlayPurchaseRequest(
    val purchaseToken: String
)

@Serializable
data class VerifyGooglePlayPurchaseResponse(
    val subscribed: Boolean
)

@Serializable
data class SubscriptionDetailsResponse(
    val plan: String,
    val nextBillingDate: String,
    val isCancelled: Boolean
)

class PaymentApi(private val client: ApiClient) {
    suspend fun createStripeSession(requestBody: CreateSessionRequest): CreateSessionResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/stripe/create-session",
            method = HttpMethod.Post,
            body = requestBody
        )
    }

    /**
     * Hands a Play purchase token to the backend, which verifies it against the Play Developer API
     * and grants the entitlement. The purchase is only real once this succeeds.
     */
    suspend fun verifyGooglePlayPurchase(purchaseToken: String): VerifyGooglePlayPurchaseResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/google-play/verify-purchase",
            method = HttpMethod.Post,
            body = VerifyGooglePlayPurchaseRequest(purchaseToken)
        )
    }

    suspend fun getSubscriptionDetails(): SubscriptionDetailsResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/stripe/subscription",
            method = HttpMethod.Get
        )
    }

    suspend fun cancelSubscription() {
        client.makeRequest<Unit>(
            url = "${Config.API_URL}/stripe/cancel",
            method = HttpMethod.Post
        )
    }
}